import { Component, ViewEncapsulation, input } from '@angular/core';

export interface StepItem {
  number: number;
  title: string;
  description: string;
  iconSvg?: string;
}

@Component({
  selector: 'ds-step-block',
  templateUrl: './step-block.html',
  styleUrl: './step-block.scss',
  encapsulation: ViewEncapsulation.None,
})
export class StepBlockComponent {
  readonly steps = input.required<StepItem[]>();
}
